import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/programming-language-shell.svg?component
var programming_language_shell_exports = /* @__PURE__ */ __exportAll({
	default: () => programming_language_shell_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 17 17"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "m2.4 11.4 5.1-4.6-5.1-4.7L.7 3.7l3.4 3v.1l-3.4 3zm14.2 3.3v-2.2h-8v2.2z" }, null, -1)])]);
}
var programming_language_shell_default = { render: render$1 };
//#endregion
export { programming_language_shell_default as default, programming_language_shell_exports, render$1 as render };

//# sourceMappingURL=programming-language-shell.svg.virtual.js.map